import {Route, RouteConfig} from "vue-router";
const RConHome = () => import('../views/rcon/RConHome.vue');
const FivemList = () => import('../views/rcon/FivemList.vue');
const FivemKick = () => import('../views/rcon/FivemKick.vue');
const FivemBan = () => import('../views/rcon/FivemBan.vue');
const FivemMessage = () => import('../views/rcon/FivemMessage.vue');
const MinecraftConsole = () => import('../views/rcon/MinecraftConsole.vue');

let rcon: RouteConfig[] = [
    {
        name: 'rcon',
        path: '/rcon',
        component: RConHome,
        redirect: {name: 'rcon-fivem'},
        children: [
            {
                name: 'rcon-fivem',
                path: '/rcon/fivem',
                component: FivemList,
            },
            {
                name: 'rcon-fivem-kick',
                path: '/rcon/fivem/kick/:id',
                component: FivemKick,
                props(route: Route)
                {
                    return {
                        id: parseInt(route.params.id) || 0,
                    };
                },
            },
            {
                name: 'rcon-fivem-ban',
                path: '/rcon/fivem/ban/:id',
                component: FivemBan,
                props(route: Route)
                {
                    return {
                        id: parseInt(route.params.id) || 0,
                    };
                },
            },
            {
                name: 'rcon-fivem-message',
                path: '/rcon/fivem/message',
                component: FivemMessage,
            },
            {
                name: 'rcon-minecraft',
                path: '/rcon/minecraft',
                component: MinecraftConsole,
            },
        ]
    },
];

export default rcon;
